import React, { useEffect } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import BulletList from '@tiptap/extension-bullet-list';
import OrderedList from '@tiptap/extension-ordered-list';
import TextAlign from '@tiptap/extension-text-align';
import Placeholder from '@tiptap/extension-placeholder';
import Heading from '@tiptap/extension-heading';
import Link from '@tiptap/extension-link';
import styles from './RichTextEditor.module.css';
import Toolbar from './Toolbar';
import TipTapDocument from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import TextStyle from '@tiptap/extension-text-style';

type RichTextEditorProps = {
  defaultValue?: string,
  onChange?: (value: string) => void,
  placeholder?: string,
};

export default function RichTextEditor({
  value = '',
  onChange,
  placeholder = '',
}: RichTextEditorProps) {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Underline,
      TextAlign.configure({
        types: ['heading', 'paragraph'],
      }),
      BulletList,
      OrderedList,
      Placeholder.configure({
        placeholder: placeholder,
      }),
      Heading,
      Link.configure({
        openOnClick: false,
      }),
      TipTapDocument,
      Paragraph,
      Text,
      TextStyle,
    ],
    content: value,
    onUpdate: event => {
      if (onChange) {
        onChange(event.editor.getHTML());
      }
    },
  });

  useEffect(() => {
    if (value && editor && value !== editor.getHTML()) {
      editor.commands.setContent(value);
    }
  }, [value]);

  return (
    <div className={styles.textEditorContainer}>
      <div className={styles.toolbarContainer}>
        <Toolbar editor={editor} />
      </div>
      <div className={styles.textEditorRoot}>
        <EditorContent editor={editor} className={styles.textEditor} />
      </div>
    </div>
  );
}
